// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__VfVft","control":"Checkout_control__C3zsR","actions":"Checkout_actions__kYldD","submit":"Checkout_submit__5VhyP","invalid":"Checkout_invalid__vmI6B"};